import { render, staticRenderFns } from "./TrackSelectCompilationsItem.vue?vue&type=template&id=8542c138&"
import script from "./TrackSelectCompilationsItem.vue?vue&type=script&lang=ts&"
export * from "./TrackSelectCompilationsItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports